// import { store } from './../store'
import { html, TemplateResult } from 'lit'
import { customElement } from 'lit/decorators.js'
import { MobxLitElement } from '@adobe/lit-mobx'

@customElement('pool-richtext')
export default class PoolRichtext extends MobxLitElement {
  _observer = <IntersectionObserver | null>null 

  constructor() {
    super()
  }

  public render(): TemplateResult {
    return html`
      <slot name="main-text"></slot>
      <slot name="readmore-btn"></slot>
      <slot name="more-text"></slot>
    `
  }
}
